import PropTypes from "prop-types";
import _ from "lodash";
import { List, ListItem } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import StepScrollerWithButtons from "./StepScrollerWithButtons";
import Button from "../toolkit/ButtonV1";
import "../styles/Tabs.css";
import DoneTwoToneIcon from '@mui/icons-material/DoneTwoTone';
import PlayArrowTwoToneIcon from '@mui/icons-material/PlayArrowTwoTone';
import { Box } from "@mui/material";
import CreateIcon from '@mui/icons-material/Create';
import EmptyComponent from "../utils/EmptyComponent";


export default function Tabs({
  variant,
  tabs,
  selected,
  onChange,
  refFromParent,
  IsSectionCompleted,
  NextId,
  modifiedData,
}) {
  const listRef = useRef(refFromParent);
  const [active, setActive] = useState(selected);
  useEffect(() => {

    setActive(selected);

  }, [selected]);

  function onClick(tab) {
    // if(NextId !== tab.id){
    //   setActive(NextId);
    // }

    setActive(tab.id);
    onChange?.(tab.id);

  }

  function getElementsArray() {
    const elements = listRef?.current?.children || [];
    return [...elements];
  }

  return (
    <StepScrollerWithButtons
      // className="tab-stepper"
      getElementsArray={getElementsArray}
    >
      <nav>
        <List
          className={`${variant}-tabs`}
          sx={{ padding: "0.25rem", }}
        // ref={listRef}

        >
          {tabs.map((i, idx) => (
            <ListItem
              className={`tab ${active === i.id ? "active" : ""}`}
              key={i.id}
              disableGutters

              onClick={() => onClick(i)}
              style={{ color: active === i.id ? "black" : "black", fontSize: active === i.id ? "16px" : "", backgroundColor: active === i.id ? "var(--orange50)" : "var(--blue50)" }}
            >

              <Button
                role="linkGrey"
                size="small"
                // label={i.text ===null ? "Tab":i.text}
                label={i.text}
                onClick={() => onClick(i)}
                disabled={i.disabled}
                title={i.disabledMessage || ""}
                {...i}
                style={{ color: active === i.id ? "black" : "black", fontSize: active === i.id ? "16px" : "" }}
              />
              {IsSectionCompleted == true ?
                <Box className="mx-1" onClick={() => onClick(i)}>
                 <DoneTwoToneIcon hidden={i.id === selected} sx={{ color: "#fff", fontSize: "medium", backgroundColor: "#12B76A", borderRadius: "20px" }} />
                 <CreateIcon  sx={{ color: "#fff", fontSize: "large", backgroundColor:  "#12B76A" , borderRadius: "20px", display: i.id === selected ? "block" : "none", fontSize: "medium", padding: "2px" }} />
                </Box> :
                <Box className="mx-1" onClick={() => onClick(i)}>
                  <DoneTwoToneIcon hidden={i.id === selected} sx={{ color: "#fff", fontSize: "medium", backgroundColor: "#12B76A", borderRadius: "20px", display: i.status === "completed" ? "block" : "none" || i.id === selected }} />
                  <PlayArrowTwoToneIcon hidden={i.id === selected} sx={{ color: "#fff", fontSize: "medium", backgroundColor: "#EE3F3F", borderRadius: "20px", display: i.status === "pending" ? "block" : "none" }} />
                  <CreateIcon hidden={!i.status} sx={{ color: i.status === "completed" || "pending" ? "#fff" : "#667085", fontSize: "large", backgroundColor: i.status === "completed" ? "#12B76A" : "F2F4F7" || i.status === "pending" ? "#EE3F3F" : "F2F4F7", borderRadius: "20px", display: i.id === selected ? "block" : "none", fontSize: "medium", padding: "2px" }} />
                </Box>
              }
            </ListItem>
          ))}

        </List>
      </nav>
    </StepScrollerWithButtons>
  );
}

Tabs.propTypes = {
  /**
   * Variant:  outlined or underlined or box
   */
  variant: PropTypes.string,
  /**
   * Array of tab definitions
   */
  tabs: PropTypes.arrayOf(PropTypes.object),
  /**
   * Selected - id of selected item
   */
  selected: PropTypes.number || PropTypes.string
};

Tabs.defaultProps = {
  variant: "outlined",
  disabled: false,
};
